import H3 from './H3';
import theme from '../theme';
import fn from '../../helpers/fn';

const SubTitle = H3.withComponent('div');

export default fn(__filename, SubTitle.extend`
  color: ${theme.colors.gray6};
  font-size: 16px;
  font-weight: 600;
  margin-bottom: ${theme.unit * 2}px;
`);



// WEBPACK FOOTER //
// ./src/components/headings/FooterTitle.js